import React from 'react';
import { Box } from '@mui/material';
import { Positions } from './Positions';

export const SimpleView = props => {
  const { positions } = props;

  return (
    <Box>
      <Positions positions={positions}></Positions>
    </Box>
  );
};
